/**
 * Solana Network Configuration
 */

const NETWORK = "mainnet-beta";
export const SOLANA_NETWORK = NETWORK as "devnet" | "mainnet-beta" | "testnet";

export const SOLANA_RPC_ENDPOINT = "https://holy-still-voice.solana-mainnet.quiknode.pro/c83f86e5b595a6295ad2037ac89593486179e6dd"; //clusterApiUrl(SOLANA_NETWORK, true);

export const SOLANA_CONFIG = {
  network: SOLANA_NETWORK,
  rpcEndpoint: SOLANA_RPC_ENDPOINT,
} as const;
